import { useEffect, useState } from 'react';
import tokenService from 'services/token';

export const useFlag = (flagIds: string[]) => {
  const [hasFlag, setHasFlag] = useState(false);

  useEffect(() => {
    tokenService
      .getToken()
      .then((token) => tokenService.parseJwt(token))
      .then((tokenObj) => flagIds.includes(String(tokenObj.id)))
      .then(setHasFlag);
  }, [flagIds]);

  return hasFlag;
};
